import React from "react";
import classnames from "classnames";
import _ from "lodash";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import { Glyphicon } from "react-bootstrap";

import { formatDate } from "../../../../../../utils/dates";
import styles from "./Message.scss";

class Message extends React.Component {
  render() {
    const message = this.props.message;
    const project = this.props.project;

    const action = message.action;
    const projectId = _.get(project, "id");
    const companyId = _.get(project, "user.profile.company_id");

    const isFromCurrentUser = _.get(message, "from.stripe_id");
    const footerFromText = isFromCurrentUser
      ? "You"
      : `${message.from.first_name} ${message.from.last_name}`;
    const footerText = `${footerFromText} on ${formatDate(
      message.created_at,
      "MMM DD, YYYY, h:mm a"
    )}`;

    let url;
    const sowUrl = `/admin/project/${projectId}/sow`;
    const invoiceUrl = `/admin/company/${companyId}`;

    if (action) {
      if (action.endsWith("submitted the SOW")) {
        url = sowUrl;
      } else if (action.endsWith("submitted an invoice")) {
        url = invoiceUrl;
      }
    }

    return (
      <div className={styles.messageContainer}>
        <div
          className={classnames(styles.message, {
            [styles.messageRight]: isFromCurrentUser
          })}
        >
          {this.renderHeader()}
          <div className={styles.messageText}>
            {(url && (
              <Link to={url}>{ReactHtmlParser(message.message)}</Link>
            )) ||
              ReactHtmlParser(message.message)}
          </div>
          {this.renderAttachment()}
        </div>

        <div
          className={classnames(styles.messageFooter, {
            [styles.messageFooterRight]: isFromCurrentUser
          })}
        >
          {footerText}
        </div>
      </div>
    );
  }

  renderHeader() {
    const isFromCurrentUser =
      _.get(this.props.message, "from.email") ===
      localStorage.getItem("userEmail");
    const action = this.props.message.action;

    const component = (
      <div
        className={classnames(styles.messageHeader, {
          [styles.messageHeaderRight]: isFromCurrentUser
        })}
      >
        {action}
      </div>
    );

    return action ? component : null;
  }

  renderAttachment() {
    const { id, attachment_name } = this.props.message;

    const component = (
      <div className={styles.messageAttachment}>
        <div className={styles.messageAttachmentContent}>
          <div className={styles.messageAttachmentContentText}>
            Attachment: {attachment_name}
          </div>
          <div
            className={styles.messageAttachmentContentButton}
            onClick={() => this.props.downloadAttachment(id)}
          >
            {this.props.loading ? (
              <Glyphicon glyph="option-horizontal" />
            ) : (
              <Glyphicon glyph="arrow-down" />
            )}
          </div>
        </div>
      </div>
    );

    return attachment_name ? component : null;
  }
}

export default Message;



// WEBPACK FOOTER //
// ./src/routes/admin/project/messages/components/Message/Message.js